export default __webpack_public_path__ + "locales/pt-BR/Settings.json?hash=d36bd8d1ed2c676a4654a7111632a1fd";